(function() {

    if ((typeof window.EngravingItem === 'undefined') || window.EngravingItem === null) {

        window.EngravingItem = (function() {

            let id = '42141421338783';
            
            let variantItemID = null;

            let getItemId = function() {
                return id;
            };

            let setItem = function(qty) {
                // Set the engraving item
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                config.body = JSON.stringify({ 
                    id: id,
                    quantity:qty 
                });

                fetch(`${routes.cart_add_url}`, config)
                    .then(response => response.json())
                    .then(data => {
                        // console.log('data: ', data);
                    });
            };

            // Update the quantity of the item 
            let updateItem = function (qty) {

                let configOption = `${id}:${qty}`;

                const body = JSON.stringify({
                    updates: {
                        [id]: qty
                    }
                });

                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
                    .then(response => response.json())
                    .then(data => {
                        // console.log('Update data: ', data);
                    });
            };

            let updateSelector = function(qty, element) {
                element.value = qty;
            };

            let isEngraving = function(element) {
                let isEngraving = false;
                if (
                    ('Engraving' in element.properties && element.properties['Engraving'] != '') || 
                    ('Engraving image' in element.properties && element.properties['Engraving image'] != '')) {
                    isEngraving = true;
                }

                return isEngraving;
            };

            let setAllowEngravingText = function(itemID) {
                variantItemID = itemID;
            };

            let getAllowTextEngraving = function() {
                if (variantItemID == id) return true;
                return false;
            };

            let clearEngravingText = function() {
                let engravingText = document.querySelector('.engraving__text');
                let engravingHiddenText = document.getElementById('hc-engraving-text');
                let engravingSizeLabel = document.getElementById('engraving_size_label');
                let engravingSize = document.getElementById('hc-engraving-size');

                if (engravingText) {
                    engravingText.value = '';
                }
                if (engravingHiddenText) { 
                    engravingHiddenText.value = '';
                }
                // if (engravingSizeLabel) {
                //     engravingSizeLabel.textContent = 1;
                // }
                if (engravingSize) {
                    engravingSize.value = '';
                }
            };

            return {
                setItem: setItem,
                updateItem: updateItem,
                getItemId: getItemId,
                updateSelector: updateSelector,
                isEngraving: isEngraving,
                setAllowEngravingText: setAllowEngravingText,
                getAllowTextEngraving: getAllowTextEngraving,
                clearEngravingText: clearEngravingText
            };
        })();
    }
})();